import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CadensSharedModule } from '../../shared';
import {FileUploadModule, RadioButtonModule, ConfirmDialogModule} from 'primeng/primeng';
import {CadensBlocksModule} from '../blocks/blocks.module';

import {
    ReferentService,
    ReferentDetailComponent,
    referentRoute,
} from './';

let ENTITY_STATES = [
    ...referentRoute
];

@NgModule({
    imports: [
        CadensSharedModule,
        FileUploadModule,
        RadioButtonModule,
        CadensBlocksModule,
        ConfirmDialogModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        ReferentDetailComponent
    ],
    entryComponents: [
        ReferentDetailComponent
    ],
    providers: [
        ReferentService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensReferentModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/referent/referent.module.ts